import React, { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FilterContext } from "../../context/Filter";

const Footer = () => {
  // console.log("L2");
  
  const location = useLocation();
  const [activeL1, setActiveL1] = useState("L1");
  const {l2, setL2} = useContext(FilterContext);
  return (
    <div>
      <div className="block md:flex md:rounded-lg mt-[2.5rem] gap-4 justify-center">
        <Link
          to={"/complaint-tat"}
          className="bg-gradient-to-r from-[#196FB9] to-[#379BDB] hover:bg-blue-800 focus:ring-4 text-white p-2 rounded-lg text-center text-sm"
        >
          Complaint Summary
        </Link>

        <Link to={"/analysis"}>
          <button
            onClick={() => setL2(!l2)}
            className="bg-gradient-to-r from-[#196FB9] to-[#379BDB] hover:bg-blue-800 focus:ring-4 text-white p-2 rounded-lg text-center text-sm"
          >
            {l2 ? "L2 Analysis" : "L1 Analysis"}
          </button>
        </Link>

        <Link to={"/sso"}>
          <button className="bg-gradient-to-r from-[#196FB9] to-[#379BDB] hover:bg-blue-800 focus:ring-4 text-white p-2 rounded-lg text-center text-sm">
            SSO Analysis
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Footer;
